import React from "react";
import IconCloseButton from "../shared/IconCloseButton";
import {useSelector} from "react-redux";

import {getBodyRegionNames} from "../../utils/Utils";
import CONSTANT from "../../constants/Constant";
import {toast} from "react-toastify";
import {getNoCCQuestion, isAllAssessmentCompleted, isCCQuestionAnswered} from "./EditAssessmentUtils";
import routes from "../../constants/Routes";
import {useHistory} from "react-router-dom";
import useEditAssessmentHeaderAndFooter from "./hooks/useEditAssessmentHeaderAndFooter";
import useBiometricInEditAssessment from "./hooks/useBiometricInEditAssessment";
import useEditAssessment from "./hooks/useEditAssessment";
import './EditAssessmentHeader.scss';
import GLOBAL from "../../global";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";

const EditAssessmentHeader = () => {
    const { showCCOrPainQuestionPopUp } = useEditAssessmentHeaderAndFooter();
    const { handleOpenMovementModal } = useBiometricInEditAssessment();

    const history = useHistory();
    const editAssessmentState = useSelector(state => state.editAssessment);
    const { clearEditAssessment, handleIsAllVisibleQuestionsOfCurrentGroupAnswered } = useEditAssessment();

    const baseData = editAssessmentState?.baseData || {};
    const testId = baseData?.testId || '';
    const bodyRegionList = baseData?.bodyRegionList || [];
    const invitationType = baseData?.invitationTypeName || '';
    const isReportAvailable = baseData?.isReportAvailable || false;
    const currentGroupId = baseData?.currentGroupId || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
    const ccQuestion = editAssessmentState?.ccQuestion || {};
    const groups = editAssessmentState?.groups || [];
    const isAllAnswered = isAllAssessmentCompleted(groups, ccQuestion);
    const { isSpinealignEnabled, isExamineticsEnabled } = useTenantFeatures();

    const handleOnClickCrossBtn = async () => {
        // First validate that all mandatory questions in current group are answered
        const areAllQuestionsAnswered = handleIsAllVisibleQuestionsOfCurrentGroupAnswered();
        if(!areAllQuestionsAnswered) {
            return;
        }

        const responses = ccQuestion?.responses;

        // Only validate CC questions if they exist
        if(responses && responses.length > 0) {
            const noCCQuestion = getNoCCQuestion(responses);

            // Only show validation error if we're in the CC group and "No" option is missing
            if(!noCCQuestion && currentGroupId === CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key) {
                toast.error('No CC question not found');
                return;
            }

            // Show popup if CC question is not answered and we're in CC group
            if(!isCCQuestionAnswered(ccQuestion) && currentGroupId === CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key) {
                await showCCOrPainQuestionPopUp();
                return;
            }
        }

        // If no CC questions or CC is validated, navigate away
        clearEditAssessment();
        if (isExamineticsEnabled) {
            history.push(routes.dashboard);
        } else {
            history.push(`${routes.myAssessments}/${false}`);
        }
    }

    return (
        <>
            <div className="edit-assessment-header__container">
                    <div className="edit-assessment-header__info-container">
                        {testId && testId !== "" && <p><span className='edit-assessment-header__test-id'>Test ID: </span>{testId}</p>}
                        {(!isExamineticsEnabled && bodyRegionList.length > 0) && <p>Region: {getBodyRegionNames(bodyRegionList)}</p>}
                        {(!isSpinealignEnabled && !isExamineticsEnabled && invitationType && invitationType !== "") && <p>Invitation type: {invitationType}</p>}
                    </div>
                <div className="edit-assessment-header__button-container">
                    {(invitationType && invitationType.toLowerCase() === CONSTANT.REDIRECT_TYPE.SELF.toLowerCase()) &&
                        <button
                            className="edit-assessment-header__resume-button"
                            onClick={handleOpenMovementModal}
                            disabled={isReportAvailable || baseData?.isBlocked || (isExamineticsEnabled && !isAllAnswered)}
                        >
                            {isExamineticsEnabled ? "Resume FA" : "Resume Biometric"}
                        </button>
                    }
                    <div className="edit-assessment-header__close-button" onClick={handleOnClickCrossBtn}>
                        <IconCloseButton />
                    </div>
                </div>
            </div>
            <div className='edit-assessment-header__less-1024-px'>
                {(!isExamineticsEnabled && bodyRegionList.length > 0) && <p>Region: {getBodyRegionNames(bodyRegionList)}</p>}
                {(!isExamineticsEnabled && invitationType && invitationType !== "") && <p>Type: {invitationType}</p>}
            </div>
        </>
    )
}

export default EditAssessmentHeader;
